import { render } from "./SkiSchoolCreate.vue?vue&type=template&id=19a076be&scoped=true"
import script from "./SkiSchoolCreate.vue?vue&type=script&lang=js"
export * from "./SkiSchoolCreate.vue?vue&type=script&lang=js"

import "./SkiSchoolCreate.vue?vue&type=style&index=0&id=19a076be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a076be"]])

export default __exports__